/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';
import { getApiPath } from '../../store-helpers';

const DEFAULT_LIMIT = 20;

const state = {
  kiosks: { items: [], total: 0 },
  limit: DEFAULT_LIMIT,
};

const getters = {
  kiosks: state => state.kiosks,
};

function buildUrl(basePath, keyword, kioskType, limit, offset) {
  const params = new URLSearchParams();
  if (keyword) params.append('keyword', keyword);
  if (kioskType) params.append('kiosk_type', kioskType);
  params.append('limit', limit);
  params.append('offset', offset);
  return `${basePath}/kiosks?${params}`;
}

const actions = {
  fetch({ commit, state }, payload) {
    const url = buildUrl(getApiPath(payload.user), payload.keyword, payload.kioskType, state.limit, 0);
    return Vue.http.get(url)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch kiosks');
      });
  },
  loadMore({ commit, state }, payload) {
    const url = buildUrl(getApiPath(payload.user), payload.keyword, payload.kioskType, state.limit, state.kiosks.items.length);

    return Vue.http.get(url)
      .then((response) => {
        commit('APPEND_KIOSKS', response);
      })
      .catch((error) => {
        console.log(error, 'failed to load more kiosks');
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, response) {
    state.kiosks = response.data;
  },
  APPEND_KIOSKS(state, response) {
    state.kiosks = {
      items: [...state.kiosks.items, ...response.data.items],
      total: response.data.total,
    };
  },
  [mTypes.CLEAR_STATE](state) {
    state.kiosks = { items: [], total: 0 };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/kiosks/kiosks.js